import { Options, Vue } from 'vue-class-component';
import { CustomersAppRoutesEnum } from '../../router/CustomersAppRoutesEnum';
import { SessionStorageEnum } from '@/utils/SessionStorageEnum';
import { customersAppService } from '@services/customers-app.service';
import { FilterMatchMode } from 'primevue/api';
import { Customer } from '@/model/Customer';

import { AppTable } from '@sharedComponents';
import { PageHeader } from '@/components';

@Options({
  components: {
    AppTable,
    PageHeader,
  },
  beforeRouteEnter(to, from, next) {
  if (from.name && !(from.name as string).startsWith('customersapp')) {
      sessionStorage.removeItem(SessionStorageEnum.TABLE_STATE_APP_CUSTOMERS);
    }

    next();
  },
  beforeRouteLeave() {
    if (this.service?.cancelPendingRequests) {
      this.service.cancelPendingRequests();
    }
  },
})
export default class CustomersAppPage extends Vue {
  filters: any = null;

  get service() {
    return customersAppService;
  }

  get stateKey() {
    return SessionStorageEnum.TABLE_STATE_APP_CUSTOMERS;
  }

  get newCustomerRoute() {
    return {
      name: CustomersAppRoutesEnum.CUSTOMERS_APP_DETAIL,
      params: { customerId: 'new' },
    };
  }

  get driverOptions() {
    return [
      { label: 'Sì', value: '1' },
      { label: 'No', value: '0' },
    ];
  }

  goToDetail(customer: Customer) {
    this.$router.push({
      name: CustomersAppRoutesEnum.CUSTOMERS_APP_DETAIL,
      params: { customerId: customer.id },
    });
  }

  private initFilter() {
    this.filters = {
      global: {
        value: null,
        matchMode: FilterMatchMode.CONTAINS,
      },
      name: {
        value: null,
        matchMode: FilterMatchMode.STARTS_WITH,
      },
      surname: {
        value: null,
        matchMode: FilterMatchMode.STARTS_WITH,
      },
      email: {
        value: null,
        matchMode: FilterMatchMode.CONTAINS,
      },
      user_phone: {
        value: null,
        matchMode: FilterMatchMode.CONTAINS,
      },
      community_transporter: {
        value: null,
        matchMode: FilterMatchMode.EQUALS,
      },
    };
  }

  created() {
    this.initFilter();
  }
}
